module.exports = __webpack_public_path__ + "img/award.29f047b2.svg";